import nodeWaves from 'node-waves/src/js/waves';

window.Waves = nodeWaves;
